



























import { IPlanProducts } from "@/interfaces/IPlanProduct";
import { PPE_PRODUCT_TYPE } from "@/services/Enums";
import { General } from "@/services/General";
import axios from "axios";
import {  Vue, Prop, Component } from "vue-property-decorator";

@Component
export default class PlanProductsDetail extends Vue {
    @Prop({
            required: true
        })
    planHeaderId: string;
    @Prop({
        required: true
    })
    productType: number;

    productList: Array<IPlanProducts> = [];
    showLoading: boolean = false;

    async mounted() {
        await this.getPlanProducts();
    }

    async getPlanProducts() {
        let endpoint: string = "";
        this.showLoading = true;
        switch(this.productType) {
            case PPE_PRODUCT_TYPE.INCLUDED:
                endpoint = "GetPlanProductsIncluded";
                break;
            case PPE_PRODUCT_TYPE.EXCLUDED:
                endpoint = "GetPlanProductsExcluded";
                break;
            case PPE_PRODUCT_TYPE.COST_ALLOCATION:
                endpoint = "GetPlanProductsCostAllocation";
                break;
        }

        try {
            let response = await axios({
                method: 'get',
                url: General.GetApiUrl('/api/ppe/' + endpoint + '?planHeaderId=' + this.planHeaderId),
                responseType: 'json',
                withCredentials: true
            });
            this.productList = response.data;
            this.showLoading = false;
        } catch (error) {
            General.HandleError(error, this);
            this.showLoading = false;
        }
    }
}
